import { View, Text } from '@react-pdf/renderer'
import { styles } from '../styles'

export function LimitationsBox({ text }) {
  return (
    <View style={styles.limitationsContainer}>
      <Text style={styles.limitationsLabel}>Limitations on the inspection</Text>
      <View style={styles.limitationsBox}>
        <Text style={styles.limitationsText}>{text || ''}</Text>
      </View>
    </View>
  )
}

export default LimitationsBox
